import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { FreightlancerBrowseCategoryComponent } from './freightlancer-browse-category.component';

@NgModule({
  imports: [CommonModule, TrackingModule, UiModule],
  declarations: [FreightlancerBrowseCategoryComponent],
  exports: [FreightlancerBrowseCategoryComponent],
})
export class FreightlancerBrowseCategoryModule {}
